/* eslint-disable no-console */
/* global google */
import Vue from 'vue';
import axios from 'axios';
import Util from './util';

const app = document.getElementById('sfl-search');

const SFLSearch = {
	vm: null,
	map: null,
	bounds: null,
	mapMarkers: [],
	infoWindow: null,
	boundsPadding: 50,
	qPresent: null,
	route: null,
	waiting: false,
	InitMap() {
		setTimeout(() => {
			SFLSearch.map = new google.maps.Map(document.getElementById('results-map'), {
				center: { lat: 39.7447, lng: -75.5484 },
				zoom: 11,
				maxZoom: 25,
				minZoom: 8,
				mapTypeControl: false,
				streetViewControl: false,
				fullscreenControl: false
			});

			// Proceed once the map is idle
			google.maps.event.addListenerOnce(SFLSearch.map, 'idle', () => {
				// Set up infoWindow and event for when it's closed
				SFLSearch.infoWindow = new google.maps.InfoWindow();
				google.maps.event.addListener(SFLSearch.infoWindow, 'closeclick', () => {
					// Not doing anything here just yet
				});
				if (SFLSearch.qPresent) {
					const qProviderId = Util.GetParameterByName('ProviderId');
					SFLSearch.vm.search();
					if (qProviderId != null) {
						setTimeout(() => {
							// TODO: Show Provider Info
						}, 250);
					}
				} else {
					SFLSearch.vm.search();
				}

				google.maps.event.addListener(SFLSearch.map, 'idle', () => {
					if (!SFLSearch.waiting) {
						// SFLSearch.vm.search();
					}
				});
			});
		}, 250);
	},
	Init() {
		const qScreeningType = Util.GetParameterByName('ScreeningType');
		const qProviderId = Util.GetParameterByName('ProviderId');
		const qZipCode = Util.GetParameterByName('ZipCode');
		const qRadius = Util.GetParameterByName('Radius');
		SFLSearch.qPresent = qZipCode != null || qScreeningType != null || qProviderId != null || qRadius != null;

		if (app) {
			SFLSearch.route = app.dataset.route;
			this.vm = new Vue({
				el: app,
				data: {
					loading: false,
					radiuses: [
						{
							text: '5 mi',
							value: 8000
						},
						{
							text: '10 mi',
							value: 16100
						},
						{
							text: '15 mi',
							value: 24000
						},
						{
							text: '20 mi',
							value: 32000
						},
						{
							text: '25 mi',
							value: 40000
						}
					],
					mode: 'list',
					screeningTypes: [
						{
							id: 'recaeuZldlSaeI1L1',
							name: 'Breast'
						},
						{
							id: 'rec0AwFc4lsQ5bwqE',
							name: 'Cervical'
						},
						{
							id: 'rec3TyGpHZTwpg6cC',
							name: 'Colon'
						},
						{
							id: 'recRVYN2gVIk0UYyO',
							name: 'Lung'
						},
						{
							id: 'recjy51mM2jUlvKxi',
							name: 'Prostate'
						}
					],
					appModel: {
						Providers: [],
						SelectedProvider: null,
						SearchRequest: {
							ScreeningType: qScreeningType === null ? 'recaeuZldlSaeI1L1' : qScreeningType,
							ZipCode: qZipCode === null ? '19801' : qZipCode,
							Radius: qRadius === null ? 8000 : qRadius
						}
					}
				},
				methods: {
					search() {
						// eslint-disable-next-line no-alert
						this.loading = true;
						axios
							.get(`/api/SFLProviders`, {
								params: { ...this.appModel.SearchRequest }
							})
							.then(response => {
								this.appModel.Providers = response.data;
								this.addMapMarkers();
								this.updateUrl();
							})
							.catch(error => {
								// console.log(error);
							})
							.then(() => {
								this.loading = false;
							});
					},
					getMapRadius() {
						const bounds = SFLSearch.map.getBounds();
						const center = SFLSearch.map.getCenter();
						if (bounds && center) {
							const ne = bounds.getNorthEast();
							return google.maps.geometry.spherical.computeDistanceBetween(center, ne) / 1.5;
						}
						return 0;
					},
					resetLocations() {
						this.appModel.Providers = [];
						SFLSearch.mapMarkers.forEach(marker => {
							marker.setMap(null);
						});
					},
					changeMode(mode) {
						this.mode = mode;
						setTimeout(() => {
							SFLSearch.map.fitBounds(SFLSearch.bounds, SFLSearch.boundsPadding);
						}, 500);
					},
					scrollIntoView() {
						try {
							document
								.getElementById('results-map')
								.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
						} catch (exc) {
							// eslint-disable-next-line no-empty
						}
					},
					addMapMarkers() {
						SFLSearch.mapMarkers.forEach(marker => {
							marker.setMap(null);
						});
						SFLSearch.mapMarkers = [];
						SFLSearch.bounds = new google.maps.LatLngBounds();
						this.appModel.Providers.forEach(provider => {
							const marker = new google.maps.Marker({
								id: provider.Id,
								title: provider.Name,
								position: { lat: provider.Location.Lat, lng: provider.Location.Lng },
								map: SFLSearch.map,
								icon: {
									path:
										'M77.692,32.692C77.692,17.399,65.3,5,50,5C34.707,5,22.308,17.399,22.308,32.692c0,5.05,1.381,9.769,3.739,13.846h-0.035   L50,95l23.999-48.462h-0.038C76.332,42.461,77.692,37.743,77.692,32.692',
									fillColor: '#00B080',
									fillOpacity: 1.0,
									strokeColor: '#000000',
									strokeWeight: 1,
									scale: 0.33,
									anchor: new google.maps.Point(50, 100)
								},
								animation: google.maps.Animation.DROP
							});
							marker.addListener('click', () => {
								const infoWindowContent = document.getElementById(`provider-${provider.Id}`).innerHTML;
								SFLSearch.infoWindow.setContent(`<div class="">${infoWindowContent}</div>`);
								// SFLSearch.map.panTo(marker.position);
								this.pauseSearching();
								SFLSearch.infoWindow.open(SFLSearch.map, marker);
							});
							SFLSearch.bounds.extend(marker.position);
							SFLSearch.mapMarkers.push(marker);
						});
						setTimeout(() => {
							SFLSearch.map.fitBounds(SFLSearch.bounds, SFLSearch.boundsPadding);
							setTimeout(() => {
								SFLSearch.map.panBy(1, 1);
							}, 250);
						}, 250);
					},
					clearZIP() {
						this.scrollIntoView();
						this.appModel.SearchRequest.ZipCode = null;
						this.search();
					},
					updateUrl() {
						const params = { ...this.appModel.SearchRequest };
						let query = `?ScreeningType=${params.ScreeningType}`;
						if (params.ZipCode != null) {
							query += `&ZipCode=${params.ZipCode}`;
						}
						if (params.Radius != null) {
							query += `&Radius=${params.Radius}`;
						}
						window.history.replaceState(params, null, `${SFLSearch.route}${query}`);
					},
					isViewMobile() {
						return window.innerWidth < 1024;
					},
					locateMe() {
						// Geolocate
						if (navigator.geolocation) {
							navigator.geolocation.getCurrentPosition(
								// Success
								position => {
									// Geocode lat/lng to ZIP Code and set on appModel
									const latlng = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
									const geocoder = new google.maps.Geocoder();
									geocoder.geocode({ latLng: latlng }, (results, status) => {
										// If a good response is retrieved, pull ZIP Code from this, set it into the model and search
										if (status === google.maps.GeocoderStatus.OK) {
											if (results[0]) {
												for (let j = 0; j < results[0].address_components.length; j += 1) {
													if (results[0].address_components[j].types[0] === 'postal_code') {
														this.appModel.SearchRequest.ZipCode = results[0].address_components[j].short_name;
													}
												}
											}
										}
										this.search();
									});
								},
								// Error - just search with defaults
								error => {
									this.search();
								}
							);
						} else {
							// Search with defaults
							this.search();
						}
					},
					showMapMarker(id) {
						const clickedMarker = SFLSearch.mapMarkers.find(marker => marker.id === id);
						SFLSearch.infoWindow.setContent(clickedMarker.title);
						this.pauseSearching();
						SFLSearch.infoWindow.open(SFLSearch.map, clickedMarker);
					},
					pauseSearching() {
						SFLSearch.waiting = true;
						setTimeout(() => {
							SFLSearch.waiting = false;
						}, 3000);
					}
				},
				created() {
					// Load Google Maps script, which will call MapInit when it's ready/loaded
					const script = document.createElement('script');
					script.src =
						'https://maps.googleapis.com/maps/api/js?key=AIzaSyBRX7wzklCLGuFRHAYhjSpQIq7Efyxj7BE&libraries=places,geometry&callback=SFLMapInit';
					script.async = true;
					document.getElementsByTagName('head')[0].appendChild(script);
				}
			});
		}
	}
};

export default SFLSearch;
window.SFLMapInit = SFLSearch.InitMap;
